import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../api/productapi";
import axios from "axios";


// Base URL from environment variable or use direct API
// const BASE_URL = process.env.REACT_APP_BASE_URI || "https://elixir-back-auth.onrender.com";

// ✅ Thunk for Login API
export const loginUser = createAsyncThunk(
  "auth/loginUser",
  async (userData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_BASE_URI}/auth/login`, userData, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        withCredentials: true
      });

      return response.data; // This will be the payload in `fulfilled` state
    } catch (error) {
      console.error("Login Error:", error);

      // Check if it's a server response error
      if (error.response) {
        return rejectWithValue(error.response.data?.message || "Invalid credentials");
      }
      // Handle network errors
      else if (error.request) {
        return rejectWithValue("Network error: Unable to reach server");
      }
      // Other unexpected errors
      else {
        return rejectWithValue("An unexpected error occurred. Please try again.");
      }
    }
  }
);

//For logout user
export const logoutUser = createAsyncThunk(
  "auth/logout",
  async (postData, { rejectWithValue }) => {
    try {
      const res = await api.post("/auth/logout", postData);
      // persistStore(store).purge();
      
      
      return res.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Try logout again');
    }
  }
);

//For refresh token
export const refreshToken = createAsyncThunk(
  'auth/refresh',
  async (tokenBody, { rejectWithValue }) => {
    try {
      const res = await api.post('auth/refresh', tokenBody);
   

      if (res.status === 200) {
        return res.data
      }

    } catch (error) {
      console.error("Refresh Token Error:", error);

      if (error.response) {
        // ✅ Handle API errors (like 401 Unauthorized)
        if (error.response.status === 401) {
        localStorage.removeItem("lastroute");
          return rejectWithValue(error.response.data.detail || "Session expired. Please log in again.");
        }
        localStorage.removeItem("lastroute");
        return rejectWithValue(error.response.data?.detail || "Failed to refresh token.");
      }
      else if (error.request) {
        // ✅ Handle network errors (no response from server)
        // localStorage.removeItem("lastroute");
        return rejectWithValue("Network error. Unable to refresh token.");
      }
      else {
        // ✅ Handle unexpected errors
        return rejectWithValue("An unexpected error occurred. Try again.");
      }
    }

  }
)

//for checking userlogin to prevent back navigation and cookie clearance on refresh
export const userSession = createAsyncThunk('auth/userSession',
  async (_, { rejectWithValue }) => {
    try {


      const res = await api.get('auth/session');
      return res.data;

    } catch (error) {
      if (error.response && error.response.status === 401) {
        return null; // ✅ Instead of rejecting, return null
      }
      return rejectWithValue("Session expired, please login again");
    }
  }
)

// ✅ Auth Slice
const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    role: "",
    loading: false,
    error: null,
    isLoading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.isLoading = true;
      })
      .addCase(loginUser.fulfilled, (state, action) => {

        const userData = {
          name: action.payload.name,
          is_active: action.payload.is_active,
          message: action.payload.message
        }

        if (!action.payload.is_active) {
          state.error = "User is inactive, please contact administrator!!"
        } else {
          state.user = userData;
          state.role = action.payload.role; // Assuming API returns user details
          state.error = null;
        }
        state.loading = false;
        state.isLoading = false;

      })
      .addCase(loginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.isLoading = false;
      })
      .addCase(logoutUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(logoutUser.fulfilled, (state, action) => {
        state.user = null;
        state.role = "";
        state.error = null;
        state.token = null;
        state.loading = false;
        localStorage.removeItem('lastroute');
      })
      .addCase(logoutUser.rejected, (state, action) => {
        // state.user = null;
        // state.role = "";
        state.error = action.payload;
        // state.token = null;
        state.loading = false;
      })
      .addCase(refreshToken.pending, (state) => {
        // state.loading = true;
        state.error = null;
      })
      .addCase(refreshToken.fulfilled, (state) => {
        state.loading = false;
        state.error = null;
      })
      .addCase(refreshToken.rejected, (state, action) => {
        state.loading = false;
        state.user = null;
        state.role = ""
      })
      .addCase(userSession.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(userSession.fulfilled, (state, action) => {
        if (action.payload) {  // ✅ Only update state if user exists
          const userData = {
            name: action.payload.user.name,
            is_active: action.payload.user.is_active,
            message: action.payload.message
          }

          state.user = userData;
          state.role = action.payload.user.role;
        } else {
          state.user = null;
          state.role = "";
        }
        state.isLoading = false;
      })
      .addCase(userSession.rejected, (state) => {
        state.isLoading = false;
        state.user = null;
        state.role = "";
      })
  },
});

// ✅ Export Actions & Reducer
export const { logout } = authSlice.actions;
export default authSlice.reducer;
